import React from 'react'

/**
 * Displays the corresponding deduction rule where items and production rules
 * can be dropped.
 */
export function SrcgCykGeneralScan() {
    return (<div className='deduction-rule'>
        <div className='rule-name'>Scan:</div>
        <div className='middle-rule-part'>
            <hr/>
            <div
                className='consequence'><span className={'unbreakable'}>[A, ρ-vec]</span>
            </div>
        </div>
        <div className='side-condition'>
            <span className={'unbreakable'}>A(ρ-vec) → ε</span>&nbsp;a range instantiated rule
        </div>
    </div>)
}
